import { render, staticRenderFns } from "./DataRecordCustomColumn.vue?vue&type=template&id=26bd894e&scoped=true&"
import script from "./DataRecordCustomColumn.vue?vue&type=script&lang=js&"
export * from "./DataRecordCustomColumn.vue?vue&type=script&lang=js&"
import style0 from "./DataRecordCustomColumn.vue?vue&type=style&index=0&id=26bd894e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bd894e",
  null
  
)

export default component.exports